import React from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import HomePage from './components/HomePage';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <HomePage />
    </ErrorBoundary>
  );
};

export default App;